export default "__VITE_ASSET__BbGcBMy3__"